<template>
    <div class="inner">
        <div class="left">
            <div class="title">
                学会排名
                <div class="select-box">
                    <select @change="changeType" v-model="type1">
                        <option :value="item.value" v-for="item in type1Data" :key="item.value">
                            {{ item.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="table">
                <div class="estimate_header">
                    <ul>
                        <li>排名</li>
                        <li>学会名称</li>
                        <li>
                            <div class="select-box select2">
                                <select @change="changeType" v-model="type2">
                                    <option :value="item.value" v-for="item in type2Data" :key="item.value">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="estimate_body" ref="estimateList">
                    <div>
                        <dl v-for="(item, index) in assessData" :key="index">
                            <dd>{{ index + 1 }}</dd>
                            <dd>
                                <router-link :to="{path:'xhpm',query:{id:item.id,nav:item.name}}">
                                    {{ item.name }}
                                </router-link>
                            </dd>
                            <dd>{{ item.score }}</dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
        <div class="center">
            <div class="top">
                <icon-title title="学会各领域业务能力" class="lg" iconName="kjtzbxueke"></icon-title>
                <div class="label" @click="changeChart2">
                    <span v-for="(item,index) in chart2Label" :key="index" :class="chart2Type==item?'checked':''"
                          :data-type="item">
                        {{ item }}
                    </span>
                </div>
                <div class="chart2 chart" id="part2"></div>
            </div>
            <div class="bottom">
                <icon-title title="学会综合能力" class="lg" iconName="geleihuiyuan"></icon-title>
                <div id="multipleChart" class="chart"></div>
            </div>
        </div>
        <div class="right">
            <div class="top">
                <icon-title title="学会党的建设" iconName="wenben"></icon-title>
                <div id="setChart" class="chart"></div>
            </div>
            <div class="bottom">
                <icon-title title="学科发展对比" iconName="kjtchenglishijian"></icon-title>
                <div id="subjectChart" class="chart"></div>
            </div>
        </div>
    </div>
</template>
<script>
    import IconTitle from '@/components/icontitle';

    import {getRanking, getSynthesize, getDang, getDiscipline, getBusiness} from '@/assets/scripts/api/xhqj.js';
    const lineColor = '#2F46C1';
    const labelColor = '#B5C8FF';
    const barColor = [ '#06C0FB', '#2F46C1', '#FB058F', '#EF9412', '#30CF6F','#30CF70'];
    const pieColor = [
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        },
        {
            'line': '#30CF70',
            'area': 'rgba(48,207,112,.2)'
        },
        {
            'line': '#EF9412',
            'area': 'rgba(239,148,18,.2)'
        },
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        },
        {
            'line': '#30CF70',
            'area': 'rgba(48,207,112,.2)'
        },
        {
            'line': '#EF9412',
            'area': 'rgba(239,148,18,.2)'
        },
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        }
    ];

    const xAxis = {
        type: 'category',
        axisLabel: {
            show: true,
            textStyle: {
                color: labelColor,
                fontSize: 14
            }
        },
        axisLine: {
            lineStyle: {
                color: lineColor
            }
        },
        axisTick: {
            show: true,
            alignWithLabel: true,
            lineStyle: {
                color: lineColor,
            }
        }
    };

    const yAxis = {
        axisTick: {
            show: false
        },
        axisLine: {
            show: false
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: lineColor,
                type: 'dotted'
            }
        },
        axisLabel: {
            show: true,
            textStyle: {
                color: labelColor,
                fontSize: 12
            },
            formatter: '{value}'
        }
    };

    export default {
        name: 'ZongHeYeWuNengLi',
        components: {
            IconTitle
        },
        data() {
            return {
                type1Data: [
                    {
                        value: 0,
                        name: '全部'
                    },
                    {
                        value: 1,
                        name: '理科'
                    },
                    {
                        value: 2,
                        name: '工科'
                    },
                    {
                        value: 3,
                        name: '农科'
                    },
                    {
                        value: 4,
                        name: '医科'
                    },
                    {
                        value: 5,
                        name: '交叉学科'
                    },
                ],
                type2Data: [
                    {
                        value: 0,
                        name: '总指数'
                    },
                    {
                        value: 1,
                        name: '基础保障'
                    },
                    {
                        value: 2,
                        name: '学术发展'
                    },
                    {
                        value: 3,
                        name: '智库建设'
                    },
                    {
                        value: 4,
                        name: '科学普及'
                    },
                    {
                        value: 5,
                        name: '学会改革创新工作'
                    },
                ],
                type1: 0,
                type2: 0,
                chart2Label: [],
                chart2Type: '',
                isInitalWorldMap: false,
                splitArrOpts: {
                    show: true,
                    areaStyle: {
                        color: ['#12173c', 'transparent']
                    }
                },
                splitLineOpts: {
                    show: true,
                    lineStyle: {
                        color: lineColor
                    }
                },
                assessData: [],
                dang: [],
                meetingJoinData: [],
                dataList: [],
                scaleLenged: ['工科', '理科', '医科', '农科', '交叉学科'],
                radarAreaColor: [
                    'rgba(255, 192, 47, 0.5)',
                    'rgba(112, 214, 50, 0.5)',
                    'rgba(64, 228, 254, 0.5)',
                    'rgba(66, 149, 254, 0.5)'
                ],
                radarColor: ['#FFC02F', '#70D632', '#40E4FE', '#4295FE']
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            changeType() {
                getRanking(this.type1, this.type2).then(({data}) => {
                    this.assessData = data;
                    this.$refs.estimateList.scrollTop = 0;
                });
            },
            changeChart2(e) {

                if (e.target.nodeName == 'SPAN') {
                    this.chart2Type = e.target.dataset.type;
                    this.initChart2(this.chart2Data[this.chart2Type]);
                }
            },
            init() {

                getDang().then(({data}) => {
                    this.initChart3(data);
                });

                getBusiness().then(({data}) => {
                    this.chart2Label = data.title;
                    this.chart2Data = data;
                    this.chart2Type = this.chart2Label[0];
                    this.$nextTick(() => {
                        this.initChart2(this.chart2Data[this.chart2Type]);
                    });
                });

                getSynthesize().then(({data}) => {
                    this.multipleChart(data);
                })
                this.subjectChart();
                this.getLearnRanking();
            },
            getLearnRanking() {
                getRanking(this.type1, this.type2).then(({data}) => {
                    this.assessData = data;
                    this.$nextTick(() => {
                        this.$scrollTable(this.$refs.estimateList);
                    });
                });
            },
            initChart2(data) {
                let chart = echarts.init(document.getElementById('part2')),
                    option = this.returnBarData(data, 'label');

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart3(data) {
                let setChart = echarts.init(document.getElementById('setChart')),
                    option = this.returnBarData(data);

                setChart.setOption(option, true);
                setChart.resize();
                this.$winResize(setChart.resize);
            },
            returnBarData(data, type) {
                let option,
                    seriesData = [],
                    tooltip = {
                        trigger: 'axis',
                        axisPointer: { // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                        }
                    };

                if (this.chart2Type == '整体排行' || !type) {
                    data.list.forEach((item, index) => {

                        seriesData.push({
                            type: 'bar',
                            barWidth: '25%',
                            barGap: 1,
                            stack: '年限',
                            name: data.title[index],
                            itemStyle: {
                                normal: {
                                    show: true,
                                    color:barColor[index]
                                }
                            },
                            data: item
                        });

                    });
                } else {
                    seriesData.push({
                        type: 'bar',
                        barWidth: '25%',
                        barGap: 1,
                        stack: '年限',
                        name: data.title[0],
                        itemStyle: {
                            normal: {
                                show: true,
                                color: barColor[0]
                            }
                        },
                        data: data.list
                    });
                }

                if (this.chart2Type == '整体排行') {
                    tooltip = {
                        trigger: 'item',
                        formatter: (params) => {
                            let pIndex = params.dataIndex,
                                totalNum = Number(data.totalScroe[pIndex]).toFixed(2),
                                str = `${params.name}:${totalNum}<br/>`;

                            data.title.forEach((item, index) => {
                                str += `<i style="display: inline-block;width: 10px;height: 10px;margin-right:2px;border-radius: 50%;background: ${barColor[index]}"></i>
                                    ${item}:${data.list[index][pIndex]}<br/>`;
                            });

                            return str;
                        }
                    };
                }

                option = {
                    color: barColor,
                    tooltip: tooltip,
                    grid: {
                        left: '0',
                        right: '0',
                        bottom: '13%',
                        top: type == 'label' ? '5%' : '10%',
                        containLabel: true
                    },
                    legend: {
                        bottom: '3%',
                        data: data.title,
                        itemWidth: 15,
                        itemHeight: 15,
                        textStyle: {
                            color: [],
                            fontStyle: 'normal',
                            fontFamily: '微软雅黑',
                            fontSize: 13
                        }
                    },
                    calculable: true,
                    xAxis:  Object.assign({
                        data: data.column
                    }, xAxis),
                    yAxis: yAxis,
                    series: seriesData
                };

                return option;
            },
            multipleChart(data) {
                let multipleChart = echarts.init(document.getElementById('multipleChart')),
                    option = this.initRadarCharts(data);

                multipleChart.setOption(option, true);
                multipleChart.resize();
                this.$winResize(multipleChart.resize);
            },
            initRadarCharts(data) {
                let indicatorData = this.getchartData(data),
                    option = {},
                    lengendData = [],
                    selectedData = {};

                let seriesData = data.list.map((item, index) => {

                    lengendData.push({
                        name: data.title[index],
                        icon: 'circle',
                        textStyle: {
                            color: labelColor,
                            margin: 7
                        }
                    })

                    selectedData[data.title[index]] = index < 2 ? true : false;
                    return {
                        type: 'radar',
                        name: data.title[index],
                        data: [item],
                        symbolSize: 8,
                        lineStyle: {
                            color: pieColor[index].line
                        },
                        areaStyle: {
                            color: pieColor[index].line,
                            opacity: 0.5
                        },
                        itemStyle: {
                            color:pieColor[index].line,
                            borderWidth: 2
                        }
                    }
                })

                option = {
                    legend: {
                        align: 'left',
                        position: 'center',
                        itemWidth: 6,
                        itemHeight: 6,
                        itemGap: 20,
                        bottom: '3%',
                        selected: selectedData,
                        data: lengendData
                    },
                    tooltip: {
                        show: true,
                        trigger: 'item'
                    },
                    radar: {
                        radius: '60%',
                        splitNumber: 2,
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        splitArea: false,
                        splitLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        name: {
                            textStyle: {
                                color: labelColor,
                                padding: [3, 5]
                            }
                        },
                        indicator: indicatorData
                    },
                    series: seriesData
                };

                return option;
            },
            getchartData(data) {
                let indicatorData = [];

                let numData = data.list.map((item) => {
                    return Math.max.apply(null, item);
                })

                data.column.forEach((item) => {
                    let max = Math.max.apply(null, numData),
                        obj = {
                            name: item,
                            max: max
                        };

                    indicatorData.push(obj);
                });

                return indicatorData;
            },
            subjectChart() {
                let subjectChart = echarts.init(document.getElementById('subjectChart'));

                getDiscipline().then(({data}) => {
                    let option = {
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: { // 坐标轴指示器，坐标轴触发有效
                                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                            }
                        },
                        legend: {
                            bottom: '3%',
                            data: data.title,
                            itemWidth: 15,
                            itemHeight: 15,
                            textStyle: {
                                color: [],
                                fontStyle: 'normal',
                                fontFamily: '微软雅黑',
                                fontSize: 13
                            }
                        },
                        grid: {
                            left: '0',
                            right: '0',
                            bottom: '10%',
                            containLabel: true
                        },
                        calculable: false,
                        xAxis:  Object.assign({
                            data: data.column
                        }, xAxis),
                        yAxis: yAxis,
                        series: [
                            {
                                name: '最高值',
                                type: 'bar',
                                barWidth: 20,
                                barGap: '0',
                                itemStyle: {
                                    normal: {
                                        color: barColor[0]
                                    }
                                },
                                data: data.list[0]
                            },
                            {
                                name: '最低值',
                                type: 'bar',
                                barGap: '0',
                                barWidth: 20,
                                itemStyle: {
                                    normal: {
                                        color: barColor[1]
                                    }
                                },
                                data: data.list[1]
                            },
                            {
                                name: '平均分',
                                type: 'line',
                                smooth: true,
                                symbol: 'none',
                                itemStyle: {
                                    normal: {
                                        color: barColor[2]
                                    }
                                },
                                data: data.list[2]
                            }]
                    };

                    subjectChart.setOption(option, true);
                    subjectChart.resize();
                    this.$winResize(subjectChart.resize);
                });

            }
        }
    };
</script>
<style lang="scss" scoped>
    @import "@/assets/scss/mixins/_mixins.scss";

    $titleColor: #B5C8FF;
    $borderColor: #17215F;
    $borderDrakColor: #080B26;

    .inner {
        padding: 2% 2.08% 0;
        font-size:.16rem;

        ::v-deep.title-line-main {
            margin-right: 0 !important;
        }

        .chart {
            width: 100%;
            height: calc(100% - 34px);
        }

        .top {
            height: 50%;
        }

        .bottom {
            height: 50%;
        }

        .left {
            float: left;
            width: 26.8%;
            height: 100%;

            .title {
                text-align: left;
                font-size: .18rem;
                font-weight: bold;
                color: $titleColor;
                line-height: .4rem;
                height: .4rem;
                padding-left: 2.9%;
                position: relative;
                background: url('~@/assets/images/xsjl/part3-title.png') no-repeat center 55% / 108% 130%;

                .select-box {
                    width: 26.54%;
                    @include position(absolute, 0, 3%);
                }
            }

            .select-box {
                width: 80%;
                height: .3rem;
                border: 1px solid #233388;

                select {
                    display: block;
                    width: 100%;
                    color: $titleColor;
                    padding: 0 .1rem;
                    height: .3rem;
                    overflow: hidden;
                    font-size: .16rem;
                    line-height: .3rem;
                    background: transparent;
                    border: none;
                }

            }


            .table {
                margin-top: .2rem;
                height: calc(100% - .74rem);
                border:1px solid $borderColor;
            }
        }

        .right {
            @extend .left;
            float: right;
        }

        .center {
            float: left;
            width: 43%;
            height: 100%;
            margin: 0 1.6%;

            .label {
                height: .6rem;
                overflow: hidden;
                margin-top: .2rem;
                box-sizing: border-box;
                span {
                    float: left;
                    border: 1px solid #40E4FE;
                    color: #40E4FE;
                    border-radius: 10px;
                    padding:0 .1rem;
                    height: .5rem;
                    line-height: .5rem;
                    margin-right: .2rem;
                    cursor: pointer;
                }
                .checked {
                    border: 1px solid #FFC02F;
                    color: #FFC02F;
                }
            }
            .chart2 {
                height: calc(100% - 1.44rem);
            }
        }
    }

    .estimate_header {
        @include clearfix;
        background: #0c1837;
        border-top:1px solid $borderColor;

        .select2 {
            height: .3rem;
            color: #40E4FE;
            margin:.1rem auto;
        }

        ul {
            width: 100%;

            li {
                float: left;
                height: .6rem;
                line-height: .6rem;
                color: $titleColor;
                text-align: center;
                border-right: 1px solid $borderColor;

                &:nth-child(1) {
                    width: 10%;
                }

                &:nth-child(2) {
                    width: 50%;
                }

                &:nth-child(3) {
                    width: 40%;
                    border-right: 0;
                }
            }
        }
    }

    .estimate_body {
        height: calc(100% - .8rem);
        overflow-y: hidden;
        border-top:1px solid $borderColor;

        dl {
            @include clearfix;

            &:nth-of-type(even) {
                background-color: #141D51;
            }

            dd {
                float: left;
                height: .6rem;
                line-height: .6rem;
                color: $titleColor;
                text-align: center;
                border-right: 1px solid $borderColor;
                border-top: 1px solid $borderColor;
                a {
                    color: $titleColor;
                }

                &:nth-child(1) {
                    width: 10%;
                }

                &:nth-child(2) {
                    width: 50%;
                    @include text-truncate();
                    padding: 0 2%;
                }

                &:nth-child(3) {
                    width: 40%;
                    color: #FFC02F;
                    border-right: 0;
                }
            }
        }
    }


</style>